const getColor = (rank, primaryColor, secondaryColor) =>
	rank % 2 ? secondaryColor : primaryColor

const innerBoxShadow = color =>
	`
		-moz-box-shadow:    inset 0 0 0 0.16em ${color};
		-webkit-box-shadow: inset 0 0 0 0.16em ${color};
		box-shadow:         inset 0 0 0 0.16em ${color};
	`

const outerBoxShadow = color =>
	`
	from {
		-webkit-box-shadow: 0px 0px 0px 1px ${color};
		-moz-box-shadow: 0px 0px 0px 1px ${color};
		box-shadow: 0px 0px 0px 1px ${color};
		opacity: 0.5;
	}

	to {
		-webkit-box-shadow: 0px 0px 0px 7px ${color};
		-moz-box-shadow: 0px 0px 0px 7px ${color};
		box-shadow: 0px 0px 0px 7px ${color};
		opacity: 0;
	}
	`

export { getColor, innerBoxShadow, outerBoxShadow }



// WEBPACK FOOTER //
// ./src/artzu-ui/src/ProgressBar/progressHelpers.js